import { useResultsNavigation } from './resultsView/useResultsNavigation';
import { useCompanyLogos } from './resultsView/useCompanyLogos';
import { useCompanyCards } from './resultsView/useCompanyCards';
import { useCompanySelection } from './resultsView/useCompanySelection';
import { useCoverageList } from './resultsView/useCoverageList';
import { useEmissionState } from './resultsView/useEmissionState';
import { usePlanSelection } from './resultsView/usePlanSelection';
import { useQuoteDownload } from './resultsView/useQuoteDownload';
import { useQuoteEmail } from './resultsView/useQuoteEmail';
import { useQuoteWhatsApp } from './resultsView/useQuoteWhatsApp';
import { useQuoteSources } from './resultsView/useQuoteSources';
import { useRecotizar } from './resultsView/useRecotizar';
import { getCoberturaDetalle, getCoberturaKey } from './resultsView/coverage';
import { formatCurrencyStatistic, formatPrice, formatSumaAsegurada } from './resultsView/formatters';
import type { ResultsViewEmit } from './resultsView/types';
import type { ResultsViewProps } from '@/components/widget/results/results-view.types';

export function useResultsView(props: Readonly<ResultsViewProps>, emit: ResultsViewEmit) {
  const { quoteGeneration, sources } = useQuoteSources(props);
  const logos = useCompanyLogos();
  const plan = usePlanSelection();
  const selection = useCompanySelection(sources);
  const navigation = useResultsNavigation(emit);
  const { selectedCompany, isChubbSelected } = selection;
  const download = useQuoteDownload({ sources, plan, isChubbSelected });
  const shareCtx = { sources, isChubbSelected, onEditDriver: navigation.handleEditDriver };
  const recotizar = useRecotizar({ quoteGeneration, sources, plan, selectedCompany, emit });
  const emission = useEmissionState({ props, sources, selectedCompany });

  return {
    ...sources,
    ...logos,
    ...plan,
    ...selection,
    ...navigation,
    ...download,
    ...useQuoteEmail(shareCtx),
    ...useQuoteWhatsApp(shareCtx),
    ...recotizar,
    ...emission,
    ...useCompanyCards(sources, logos),
    ...useCoverageList(selection.selectedQuotes),
    formatPrice,
    formatCurrencyStatistic,
    formatSumaAsegurada,
    getCoberturaDetalle,
    getCoberturaKey,
  };
}
